import { validateAddress, validateEmail, validatePhoneStruct, validateZip, } from "../../helpers/getFormRulesMessages/getFormRulesMessages";
export var PROFILE_UPDATE_CUSTOM_FORM_FIELD_VALIDATORS = {
    "mailingAddress.street1": validateAddress,
    "mailingAddress.zipCode": validateZip,
    "phoneNumbers.mobile": validatePhoneStruct,
    "phoneNumbers.home": validatePhoneStruct,
    "phoneNumbers.business": validatePhoneStruct,
    emailAddress: validateEmail,
};
